import {
	DeleteOutlined,
	CloseOutlined,
	EditOutlined,
	SaveOutlined,
	UploadOutlined,
	FileDoneOutlined,
	LoadingOutlined,
} from "@ant-design/icons";
import { defaultProps, IconColor, iconColorMap, IconName, IconProps, IconSize, iconSizeMap } from "./Icon.type";

const defineColor = (iconColor?: IconColor, disabled?: boolean) => {
	if (disabled || !iconColor) {
		return IconColor.Grey;
	}

	return iconColorMap[iconColor];
};

export const Icon = (props: IconProps) => {
	const {
		name,
		iconColor,
		onClick,
		iconSize = IconSize.Default,
		disabled = false,
		...attribute
	} = { ...defaultProps, ...props };

	const formattedProps = {
		onClick: disabled ? undefined : onClick,
		style: {
			fontSize: iconSizeMap[iconSize],
			color: defineColor(iconColor, disabled),
			hover: "not-allowed"
		},
	};

	switch (name) {
		case IconName.Delete:
			return <DeleteOutlined {...formattedProps} {...attribute} />;
		case IconName.Save:
			return <SaveOutlined {...formattedProps} {...attribute} />;
		case IconName.Edit:
			return <EditOutlined {...formattedProps} {...attribute} />;
		case IconName.Close:
			return <CloseOutlined {...formattedProps} {...attribute} />;
		case IconName.Upload:
			return <UploadOutlined {...formattedProps} {...attribute} />;
		case IconName.Done:
			return <FileDoneOutlined {...formattedProps} {...attribute} />;
		case IconName.Loading:
			return <LoadingOutlined {...formattedProps} {...attribute} />;
		default:
			return null;
	}
};
